export default "__VITE_ASSET__BV_1vx5i__"